import React, { Component } from 'react';
import Spinner from '../sample/spinner';
import axios from "axios";
import { Card, CardBody, Col, Row, TabContent, TabPane, CardImg, CardSubtitle, Nav, NavItem, NavLink, } from "reactstrap";
// import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import StickyBox from "react-sticky-box";
import classnames from 'classnames';
import { toast } from "react-toastify";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    // paritialVisibilityGutter: 260,
    slidesToSlide: 2 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 550 },
    items: 1,
    paritialVisibilityGutter: 30,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 550, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
    slidesToSlide: 1 // optional, default to 1.
  }
};
class Explore extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: ""
    };
    const courses = [];
    this.state = { isLoading: false, courses };
  }
  toggle(tab) {
    //  alert(tab);
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  componentDidMount() {
    this.getAllCourses();
  }
  async getAllCourses() {
    this.setState({ isLoading: true });
    axios
      .post("Sample/explore")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            isLoading: false,
            activeTab: res.data.course[0]?.catagoryname,
            courses: res.data.course
          });
         // console.log("itam-data", res.data.course[2].catagory.length);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  render() {
    return (
      <div className="courseschedule12 padding-default bg-color1">
        {this.state.isLoading ? (
          <Spinner />
        ) : (
          ""
        )}
        {/* <h2 className="my-course-heading">Explore course catalog</h2> */}
        {this.state.courses.length >0 ?
        <section class="courseschedule" >
          <Row> 
            <Col className="pb-4" xs="12" sm="12" md="12" ><span className="my-course-heading"> Explore Course Catalog</span>
            </Col>
          </Row>
          <Row>
            <div className="col-sm-12 col-md-4">
              <StickyBox offsetTop={95}>
                <Nav tabs vertical pills className="cards-sider">
                  {this.state.courses.map((item) => (
                    <>
                      <NavItem className="nav-click-css">
                        <NavLink
                          className={classnames({ active: this.state.activeTab === item.catagoryname })}
                          onClick={() => {
                            this.toggle(item.catagoryname);
                          }} >
                          {item.catagoryname}  ({item.catagory.length})
                        </NavLink>
                      </NavItem>
                    </>
                  ))}
                </Nav>
              </StickyBox>
            </div>
            <div className="col-sm-12 col-md-8">
        
              {this.state.courses.map((item) => (
                <>
                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={item.catagoryname}>
                      <Row className="pt-2 mt-32w choose-course">
                        {item.catagory.map((sub) => (
                          <Col lg="5" className="pb-5 ml-5">
                            <Card key={sub.id}>
                              <CardImg top width="100%" className="height-card-img" src={sub.crsimage} alt="Card image cap" />
                              <CardBody>
                                <CardSubtitle className="subtitle-card-head" tag="h5">{sub.coursename}</CardSubtitle>
                                <Link to={{
                                  pathname: "/Explore/" + sub.staticlink,
                                  params: { courseid: sub.id },
                                }} >
                                  <button
                                    color="primary"
                                    style={{ borderRadius: 30 }}
                                    className=" btn btn-getstarteds ttxt-f shef-btn"
                                  >
                                    Know More
                            </button>
                                </Link>
                              </CardBody>
                            </Card>

                          </Col>
                        ))}
                      </Row>
                    </TabPane>
                  </TabContent>
                </>
              ))}
            </div>
          </Row>
          <section class="our-courses-featured">
            <div id="stop-sticky"></div>
          </section>
        </section>:""}
      </div>
    );
  }
}

export default Explore;